<template>
<div>
  <div class="main-content">
    <div class="content">
      <div class="nest-contents">
        <p>利用規約を確認し、メールアドレスを送信してください。</p>
        <div class="get-start-pre-form pure-form">
          <form id="form" @submit="sendMail">
            <div class="fieldset">
              <label for="email">メールアドレス*</label>
              <input type="email" id="email-input" placeholder="example@norimemo.com" name="email" required v-model="email">
              <span class="pure-form-message err-message" id="email-input-error">{{ emailError }}</span>
            </div>
            <div class="terms-of-service">
              <terms/>
            </div>
            <button id="send" class="pure-button pure-button-primary">送信</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import terms from "@/components/terms.vue"

export default {
  components: {
    terms,
  },

  data() {
    return {
      email: "",
      actionCodeSettings: {
        url: window.location.protocol + '//' + window.location.host + '/compleate_registration',
        // This must be true.
        handleCodeInApp: true
      },
      emailError: "",
    }
  },

  methods: {
    sendMail(e) {
      var params = new URLSearchParams()
      params.append("email", this.email)

      this.$http.post("comfirmation_email/sign_up", params).then(() => {
        this.$firebase.auth().sendSignInLinkToEmail(this.email, this.actionCodeSettings)
          .then(() => {
            this.$store.dispatch("setEmail", this.email)
            this.$router.push({ name: "sent_email", params: { type: "sign_up" } })
          })
      }).catch((err) => {
        if (err.response.data.message) {
          this.emailError = err.response.data.message
        }
      })

      e.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-of-service {
  width: 70%;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 20px;
  border: solid 1px #000000;
}

.pure-button-primary {
  background: linear-gradient(180deg, #fff5ee, #83ccd2);
  color: #000000;
}

@media screen and (max-width: 420px) {
  .terms-of-service {
    width: 100%;
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>